import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function() {
        const splideElements = document.querySelectorAll('.google-reviews-slider__slider.splide');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                const options = JSON.parse(splideElement.getAttribute('data-splide'));
                const splide = new Splide(splideElement, options);
                splide.mount();
            });
        }
    };
    
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=google-reviews-slider', initializeBlock);
    } else {
        initializeBlock();
    }
});
